'use strict';

import layout from './layout';

const scrollTop = (offset, duration) => {
	duration = duration || 200;

	if (offset > 0) {
		const $siteHeader = layout.isDesktop() ? $('.site-header-desktop') : $('.site-header-mobile');
		if ($siteHeader.length > 0 && offset > $siteHeader.height()) {
			offset = offset - $siteHeader.height();
		}
	}

	if (duration > 0) {
		$('html, body').animate({
			scrollTop: offset
		}, duration);
	} else {
		$('html, body').css('scrollTop', offset);
	}
}

const scrollIfNotInView = ($element, duration, scrollTopOffset) => {
	if (!scrollTopOffset) {
		scrollTopOffset = 0;
	}

	const elementTop = $element.offset().top - scrollTopOffset;
	const elementBottom = elementTop + $element.outerHeight();
	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	if (elementBottom < viewportTop || elementTop > viewportBottom)
	{
		scrollTop(elementTop, duration);
	}
}

export default {
	scrollTop,
	scrollIfNotInView
}